export enum FieldSource {
  Catalog = 'catalog',
  Deeptag = 'deeptag',
}

export const fieldSourceDropDownOptions = [
  { value: FieldSource.Catalog, text: 'Catalogue Filter' },
  { value: FieldSource.Deeptag, text: 'Deeptag Filter - coming soon', disabled: true },
];
